<template>
	<div class="ShopCell">
		<div class="topDiv" @click="pushPath(path)">
			<div class="nameTyp">{{name}}</div>
			<div class="imgTyp iconfont">&#xe600;</div>
		</div>
		<div class="BottomLine"></div>
	</div>
</template>

<script>
	export default {
		name:'ShopCell',
		props:{
			name:{
				type:String
			},
			path:{
				type:String
			},
			imageTyp:{
				type:String
			},
		},
		data() {
			return{
				
			}
		},
		methods:{
			pushPath(e){
				console.log("e",e);
				// this.$router.push({
				// 	path: '/' + e,
				// })
				window.open(e,'_self')
			}
		}
	}
</script>

<style>
	@font-face {
		font-family: 'iconfont';
		/* project id 1631181 */
		src: url('//at.alicdn.com/t/font_1631181_emed4wmv0s9.eot');
		src: url('//at.alicdn.com/t/font_1631181_emed4wmv0s9.eot?#iefix') format('embedded-opentype'),
			url('//at.alicdn.com/t/font_1631181_emed4wmv0s9.woff2') format('woff2'),
			url('//at.alicdn.com/t/font_1631181_emed4wmv0s9.woff') format('woff'),
			url('//at.alicdn.com/t/font_1631181_emed4wmv0s9.ttf') format('truetype'),
			url('//at.alicdn.com/t/font_1631181_emed4wmv0s9.svg#iconfont') format('svg');
	}
	
	.iconfont {
		font-family: 'iconfont';
	}
	
	.ShopCell {
		width: 100%;
		height: 3.875rem;
		display: flex;
		align-items: center;
		flex-direction: column;
	}
	
	.ShopCell .topDiv {
		width: 85%;
		height: 3.750rem;
		display: flex;
		flex-direction: row;
		align-items: center ;
		justify-content:space-between;
	}
	
	.ShopCell .topDiv .nameTyp{
		font-family:Alibaba-PuHuiTi-R;
	}
	
	.ShopCell .topDiv .imgTyp{
	
	}
	
	.BottomLine {
		width: 85%;
		height: 0.0625rem;
		background-color: rgba(229,229,299,0.7);
	}
</style>
